import React from 'react'
import PropTypes from 'prop-types'
import styles from './styles.css'

const BuildFilter = ({
  defaultOption,
  name,
  onChange,
  optionsArr,
  optionLabel,
  value,
}) => (
  <select
    className={styles.filterSelect}
    value={value}
    onChange={onChange}
    name={name}
  >
    <option value="">{defaultOption}</option>
    {optionsArr.map(item => (
      <option key={item.id} value={item.id}>
        {item[optionLabel]}
      </option>
    ))}
  </select>
)

BuildFilter.propTypes = {
  defaultOption: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  optionsArr: PropTypes.arrayOf(PropTypes.object),
  optionLabel: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
}

export default BuildFilter



// WEBPACK FOOTER //
// ./src/components/OnlineScheduling/BookingPatients/BuildFilter.js